<template>
    <div class="footer">
        <div class="footer-bottom">
            <span>@2021Baidu</span>
            <a
                href="http://help.baidu.com/newadd?prod_id=218&category=4"
                style="margin-left: 30px"
            >意见反馈</a>
            <em></em>
            <a href="http://help.baidu.com/newadd?prod_id=218">投诉举报</a>
            <em></em>
            <router-link to="/app/agree" style="margin-right: 25px">平台协议</router-link>
            <span>京ICP证030173号-1</span>
            <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000001"
                style="margin-left: 25px"
            >京公网安备11000002000001号（京）-经营性-2017-0020</a>
        </div>
    </div>
</template>

<script>
/**
 * @file 底部页脚框
 * @author yinlejia
 * @categories 业务组件
 * @tags [component]
 */
export default {
    data() {
        return {};
    },
    created() {},
    computed: {},
    methods: {}
};
</script>
<style lang="less" scoped>
.footer {
    background-color: #11adb5d8;
    height: 70px;
    overflow: hidden;
    a {
        text-decoration: none;
        color: #fff;
        font-weight: 500;
        cursor: pointer;
    }
    .footer-bottom {
        width: 1000px;
        margin: 30px auto 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 12px;
        font-weight: 400;
        em {
            width: 1px;
            height: 12px;
            background-color: #fff;
            display: inline-block;
            margin: 0 20px;
        }
        a {
            font-weight: 400;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/app/Footer.vue